module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljk1IDQuMkgxNy44NVYxMy42NUg0LjJWMTUuNzVDNC4yIDE2LjM4IDQuNjIgMTYuOCA1LjI1IDE2LjhIMTYuOEwyMSAyMVY1LjI1QzIxIDQuNjIgMjAuNTggNC4yIDE5Ljk1IDQuMlpNMTUuNzUgMTAuNVYxLjA1QzE1Ljc1IDAuNDIgMTUuMzMgMCAxNC43IDBIMS4wNUMwLjQyIDAgMCAwLjQyIDAgMS4wNVYxNS43NUw0LjIgMTEuNTVIMTQuN0MxNS4zMyAxMS41NSAxNS43NSAxMS4xMyAxNS43NSAxMC41WiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/messages.svg
// module id = wgHg
// module chunks = 38